/**
 * Chat analytics. Fires events via global.trackAnalyticsEvent (GA/Fathom).
 * No PII in payloads; only event names and boolean/count flags.
 */

const CATEGORY = 'Chat';

export function trackPanelOpened(source) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'chat_panel_opened', '', source || 'fab');
  }
}

export function trackFirstMessageSent(loggedIn) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(
      CATEGORY,
      'chat_first_message_sent',
      '',
      loggedIn ? 'logged_in' : 'guest'
    );
  }
}

export function trackEscalationRequested() {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'chat_escalation_requested', '', '');
  }
}

export function trackTranscriptEmailed() {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'chat_transcript_emailed', '', '');
  }
}

export function trackDropOff(messageCount) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'chat_drop_off', '', String(messageCount));
  }
}

export function trackRegenerateClicked() {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'chat_regenerate_clicked', '', '');
  }
}

export function trackAgentMessageSent(loggedIn) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(
      CATEGORY,
      'agent_message_sent',
      '',
      loggedIn ? 'logged_in' : 'guest'
    );
  }
}

export function trackAgentError(err) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    const code = err && err.status ? String(err.status) : 'stream';
    global.trackAnalyticsEvent(CATEGORY, 'agent_error', '', code);
  }
}

export function trackToolInvoked(toolName) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'agent_tool_invoked', '', toolName || '');
  }
}

export function trackLanguageChanged(lang) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'chat_language_changed', '', lang || '');
  }
}

export function trackResizePanel(width, height) {
  if (typeof global.trackAnalyticsEvent === 'function') {
    global.trackAnalyticsEvent(CATEGORY, 'chat_panel_resized', '', `${width}x${height}`);
  }
}
